(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[518],{

/***/ 70047:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browse",
      function () {
        return __webpack_require__(91570);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50744);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70082);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56168);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99731);
/* harmony import */ var _enums_playlistType__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54071);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17651);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22135);
/* harmony import */ var _typings_api__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81962);
/* harmony import */ var _AppLink_AppLink__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3245);
/* harmony import */ var components_DramoxImage__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20010);













var CategorySection = function(param) {
    var title = param.title, plays = param.plays, theater = param.theater, playlistType = param.playlistType, id = param.id, moreHref = param.moreHref, _showResume = param.showResume, showResume = _showResume === void 0 ? false : _showResume, _mediumThumbs = param.mediumThumbs, mediumThumbs = _mediumThumbs === void 0 ? false : _mediumThumbs, _largeThumbs = param.largeThumbs, largeThumbs = _largeThumbs === void 0 ? false : _largeThumbs;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_5__/* .Namespace.Common */ .l.Common).t;
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_2__/* .useLang */ .J)().locale;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), elementTop = ref1[0], setElementTop = ref1[1];
    var query = {};
    if (playlistType !== _enums_playlistType__WEBPACK_IMPORTED_MODULE_6__/* .PlaylistType.Theater */ .e.Theater) {
        if (id) {
            query["id"] = id;
        }
        query["type"] = playlistType;
    }
    (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useCategoryRowSwiper */ .jR)(ref, plays);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        var width = 256;
        var height = 144;
        if (mediumThumbs) {
            height = 351;
        } else if (largeThumbs) {
            width = 367;
            height = 504;
        }
        return [
            width,
            height,
            height > width
        ];
    }, [
        largeThumbs,
        mediumThumbs
    ]), imageWidth = ref2[0], imageHeight = ref2[1], isImagePortrait = ref2[2];
    var cls = [
        "category-section"
    ];
    if (mediumThumbs) {
        cls.push("category-section-medium");
    } else if (largeThumbs) {
        cls.push("category-section-large");
    }
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            var ref1;
            // calculate top only once on initial render
            setElementTop(ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect().top);
        }
    }, [
        ref
    ]);
    var loadImages = (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useOnScrollElement */ .Vq)(elementTop);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cls.join(" "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                children: [
                    title,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        href: {
                            pathname: moreHref
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: t("more")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                ref: ref,
                className: "scroll-wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: "play-list swiper-wrapper",
                        children: plays === null || plays === void 0 ? void 0 : plays.map(function(play) {
                            var ref, ref1;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("swiper-slide", showResume ? "resume" : "", play.is_original ? "original" : null),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        href: _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.play */ .xm.play(play, locale),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "category-image",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_DramoxImage__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                        loadImmediately: loadImages,
                                                        placeholderClass: "img-placeholder-category-playlist",
                                                        src: play.poster_url,
                                                        alt: play.title,
                                                        width: imageWidth,
                                                        height: imageHeight,
                                                        quality: 90,
                                                        usePlaceholder: true
                                                    })
                                                }),
                                                play.state === _typings_api__WEBPACK_IMPORTED_MODULE_9__/* .PlayState.PROMOTED */ .QT.PROMOTED ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "coming-soon",
                                                    children: t("coming_soon")
                                                }) : null,
                                                !isImagePortrait && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                            children: (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .truncateTitle */ .ew)(play.title)
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: theater ? theater : play.theatre.name
                                                        })
                                                    ]
                                                }),
                                                isImagePortrait && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                            children: [
                                                                play.logo_url && largeThumbs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: play.logo_url,
                                                                    alt: play.title
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .truncateTitle */ .ew)(play.title)
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: theater ? theater : play.theatre.name
                                                        })
                                                    ]
                                                }),
                                                showResume && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        style: {
                                                            width: "".concat(((ref = play.video) === null || ref === void 0 ? void 0 : ref.user_progress) / ((ref1 = play.video) === null || ref1 === void 0 ? void 0 : ref1.runtime) * 100, "%")
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    showResume && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "play",
                                        title: t("common:play_btn"),
                                        onClick: function() {
                                            window.location.href = _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.watch */ .xm.watch(play, locale);
                                        }
                                    })
                                ]
                            }, play.id);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "#",
                        className: "control prev",
                        title: t("common:previous_play"),
                        children: t("common:previous_play")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "#",
                        className: "control next",
                        title: t("common:next_play"),
                        children: t("common:next_play")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategorySection);


/***/ }),

/***/ 80584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50744);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_links__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60041);
/* harmony import */ var context_authContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13102);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70082);
/* harmony import */ var context_popupContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30785);
/* harmony import */ var enums_namespaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99731);
/* harmony import */ var enums_popupType__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91360);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17651);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56168);
/* harmony import */ var _PlayButton_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86145);
/* harmony import */ var _PlayButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_PlayButton_module_scss__WEBPACK_IMPORTED_MODULE_10__);












var PlayButton = function(param) {
    var play = param.play, _longTitle = param.longTitle, longTitle = _longTitle === void 0 ? false : _longTitle, _alwaysOn = param.alwaysOn, alwaysOn = _alwaysOn === void 0 ? false : _alwaysOn;
    var ref;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(enums_namespaces__WEBPACK_IMPORTED_MODULE_5__/* .Namespace.Common */ .l.Common).t;
    var setPopup = (0,context_popupContext__WEBPACK_IMPORTED_MODULE_4__/* .usePopup */ .BF)().setPopup;
    var ref1 = (0,context_authContext__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .aC)(), user = ref1.user, isUserLoaded = ref1.isUserLoaded;
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_3__/* .useLang */ .J)().locale;
    var isComingSoon = play && (!(play === null || play === void 0 ? void 0 : play.video) || play.date_published_from && Date.now() < Date.parse(play.date_published_from));
    var popupType = enums_popupType__WEBPACK_IMPORTED_MODULE_6__/* .PopupType.BuySubscription */ .k.BuySubscription;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(null), ios15Content = ref2[0], setIos15Content = ref2[1];
    var cls = classnames__WEBPACK_IMPORTED_MODULE_1___default()("btn btn-primary btn-play", (_PlayButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().play), !(play && isUserLoaded || alwaysOn) ? (_PlayButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().hidden) : "", isComingSoon ? "btn-warning btn-no-events" : "");
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        if (window.navigator.userAgent.indexOf("15_0") > -1 && isUserLoaded) {
            title = t("common:open_in_mobile_app");
            link = constants_links__WEBPACK_IMPORTED_MODULE_11__/* .LINK_APP_STORE */ .c;
            setIos15Content(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: link,
                className: cls,
                tabIndex: -1,
                rel: "external",
                children: title
            }, "app"));
        }
    }, [
        isUserLoaded
    ]);
    if (ios15Content) {
        return ios15Content;
    }
    if (isComingSoon) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: cls,
            children: t("coming_soon")
        });
    }
    var title = t(longTitle ? "play_btn_long" : "play_btn");
    // no user -> login popup
    if (isUserLoaded && !user) {
        popupType = enums_popupType__WEBPACK_IMPORTED_MODULE_6__/* .PopupType.Login */ .k.Login;
    }
    // video is available
    if (play === null || play === void 0 ? void 0 : (ref = play.video) === null || ref === void 0 ? void 0 : ref.user_progress) {
        // resume play label
        if (!longTitle) {
            title = t("continue");
        } else {
            var ref3, ref4;
            title = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    t("continue"),
                    "\xa0",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: t("continue_remaining", {
                            time: (0,helpers__WEBPACK_IMPORTED_MODULE_7__/* .sec2time */ .bp)((play === null || play === void 0 ? void 0 : (ref3 = play.video) === null || ref3 === void 0 ? void 0 : ref3.runtime) - (play === null || play === void 0 ? void 0 : (ref4 = play.video) === null || ref4 === void 0 ? void 0 : ref4.user_progress))
                        })
                    })
                ]
            });
        }
    }
    var link = play ? helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.watch */ .xm.watch(play, locale) : null;
    if (user === null || user === void 0 ? void 0 : user.isSubscriber) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: link,
            className: cls,
            tabIndex: -1,
            onMouseUp: function() {
                return window.location.href = link;
            },
            children: title
        });
    }
    var _onClickShowPopup = function(e) {
        e.preventDefault();
        setPopup(popupType);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: link,
        className: cls,
        tabIndex: -1,
        onClick: _onClickShowPopup,
        children: title
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PlayButton);


/***/ }),

/***/ 91570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ browse; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./context/authContext.tsx + 3 modules
var authContext = __webpack_require__(13102);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(50744);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./helpers/index.ts + 50 modules
var helpers = __webpack_require__(17651);
// EXTERNAL MODULE: ./context/langContext.ts
var langContext = __webpack_require__(70082);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(75332);
// EXTERNAL MODULE: ./enums/namespaces.ts
var namespaces = __webpack_require__(99731);
// EXTERNAL MODULE: ./hooks/index.ts + 3 modules
var hooks = __webpack_require__(22135);
// EXTERNAL MODULE: ./components/AppLink/AppLink.tsx
var AppLink = __webpack_require__(3245);
// EXTERNAL MODULE: ./components/buttons/PlayButton/PlayButton.tsx
var PlayButton = __webpack_require__(80584);
// EXTERNAL MODULE: ./components/Carousel/index.module.scss
var index_module = __webpack_require__(11859);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/Carousel/index.tsx













var Carousel = function(param) {
    var section = param.section, linkToOriginals = param.linkToOriginals;
    var ref;
    var ref1 = (0,react.useRef)(null);
    var progressBarRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var locale = (0,langContext/* useLang */.J)().locale;
    var t = (0,useTranslation/* default */.Z)(namespaces/* Namespace.Common */.l.Common).t;
    var btnOriginal = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: linkToOriginals,
            className: "original-link",
            title: "Dramox Original",
            children: "Dramox Original"
        });
    }, [
        linkToOriginals
    ]);
    (0,react.useEffect)(function() {
        /*
    HACK
    If we lose focus on the window, carousel freezes on the current frame.
    When the window regains focus, carousel restarts the current frame but the active "spinning bullet" never re-appears.
    Hacky solution is to remove active class from the bullet and re-add it on the next render frame to start the animation again.
    */ var handleVisibilityChange = function() {
            var cls = "swiper-pagination-bullet-active";
            if (!document.hidden) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                var el = document.getElementsByClassName(cls)[0];
                el === null || el === void 0 ? void 0 : el.classList.remove(cls);
                setTimeout(function() {
                    el === null || el === void 0 ? void 0 : el.classList.add(cls);
                });
            }
        };
        document.addEventListener("visibilitychange", handleVisibilityChange, false);
        return function() {
            document.removeEventListener("visibilitychange", handleVisibilityChange, false);
        };
    }, []);
    (0,hooks/* useSwiper */.oc)(ref1, progressBarRef);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: ref1,
            className: classnames_default()("carousel-wrapper", (index_module_default()).carousel),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "dramox-carousel swiper-wrapper",
                    children: section === null || section === void 0 ? void 0 : (ref = section.plays) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "swiper-slide",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "thumb",
                                    style: {
                                        backgroundImage: "url(".concat(item.poster_url, ")")
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "links-wrapper",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: helpers/* Permalink.theatre */.xm.theatre(item.theatre),
                                                    className: "theatre-link",
                                                    children: item.theatre.name
                                                }),
                                                item.is_original && btnOriginal
                                            ]
                                        }),
                                        item.is_original && btnOriginal,
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                            children: [
                                                item.logo_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: item.logo_url,
                                                    alt: item.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: item.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: item.summary
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "buttons",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayButton/* default */.Z, {
                                                    play: item,
                                                    alwaysOn: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: helpers/* Permalink.play */.xm.play(item, locale),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "btn btn-outline-info",
                                                        tabIndex: -1,
                                                        onMouseUp: function() {
                                                            router.push(helpers/* Permalink.play */.xm.play(item, locale));
                                                        },
                                                        children: t("more_about_play")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, item.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "swiper-pagination"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/CategorySections/CategorySection.tsx
var CategorySection = __webpack_require__(74107);
// EXTERNAL MODULE: ./components/Layout/index.tsx + 12 modules
var Layout = __webpack_require__(46323);
// EXTERNAL MODULE: ./enums/index.ts + 3 modules
var enums = __webpack_require__(39933);
// EXTERNAL MODULE: ./pages/browse/index.module.scss
var browse_index_module = __webpack_require__(820);
var browse_index_module_default = /*#__PURE__*/__webpack_require__.n(browse_index_module);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(1984);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./helpers/jsx.tsx
var jsx = __webpack_require__(28808);
;// CONCATENATED MODULE: ./enums/FeaturedSectionType.ts
var FeaturedSectionType;
(function(FeaturedSectionType) {
    FeaturedSectionType["BANNER"] = "BANNER";
    FeaturedSectionType["CUSTOM"] = "CUSTOM";
    FeaturedSectionType["GENRE"] = "GENRE";
    FeaturedSectionType["POPULAR"] = "POPULAR";
    FeaturedSectionType["WATCHING"] = "WATCHING";
    FeaturedSectionType["NEWEST"] = "NEWEST";
    FeaturedSectionType["CUSTOM_MEDIUM"] = "CUSTOM_MEDIUM";
    FeaturedSectionType["ORIGINALS"] = "ORIGINALS";
    FeaturedSectionType["WATCHLIST"] = "WATCHLIST";
})(FeaturedSectionType || (FeaturedSectionType = {}));

// EXTERNAL MODULE: ./components/index.ts + 4 modules
var components = __webpack_require__(66893);
;// CONCATENATED MODULE: ./pages/browse/index.tsx

// @ts-ignore














var Browse = function(param) {
    var carouselSection = param.carouselSection, sections = param.sections, countryCode = param.countryCode;
    var t = (0,useTranslation/* default */.Z)(enums/* Namespace.Common */.lS.Common).t;
    var reloadUser = (0,authContext/* useAuth */.aC)().reloadUser;
    var locale = (0,langContext/* useLang */.J)().locale;
    var ref = (0,react.useState)(true), showSkeleton = ref[0], setShowSkeleton = ref[1];
    (0,react.useEffect)(function() {
        reloadUser();
    }, []);
    var linkToOriginals = helpers/* Permalink.dramoxOriginals */.xm.dramoxOriginals(locale);
    // wait for the first carousel image to load, then show everything
    (0,react.useEffect)(function() {
        var ref;
        if (!carouselSection) {
            setShowSkeleton(false);
        } else if (carouselSection === null || carouselSection === void 0 ? void 0 : (ref = carouselSection.plays) === null || ref === void 0 ? void 0 : ref.length) {
            // eslint-disable-next-line prefer-const
            var loadTimeout;
            var onLoad = function() {
                setShowSkeleton(false);
                clearTimeout(loadTimeout);
            };
            var img = new Image();
            img.onload = onLoad;
            img.onerror = onLoad;
            img.src = carouselSection.plays[0].poster_url;
            loadTimeout = window.setTimeout(onLoad, 3000);
        }
    }, [
        carouselSection
    ]);
    if (showSkeleton) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* BrowseSkeleton */.C_, {
            countryCode: countryCode
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: (0,jsx/* basicSEO */.F)(t("seo:browse_title"), t("seo:browse_description"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: (browse_index_module_default()).homepage,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                        section: carouselSection,
                        linkToOriginals: linkToOriginals
                    }),
                    sections.map(function(s) {
                        var link;
                        var title = s.name;
                        switch(s.type){
                            case FeaturedSectionType.POPULAR:
                                title = t("common:most_popular");
                                link = helpers/* Permalink.mostPopular */.xm.mostPopular(locale);
                                break;
                            case FeaturedSectionType.WATCHING:
                                title = t("common:currently_watching");
                                link = helpers/* Permalink.currentlyWatching */.xm.currentlyWatching(locale);
                                break;
                            case FeaturedSectionType.NEWEST:
                                title = t("common:recently_added");
                                link = helpers/* Permalink.recentlyAdded */.xm.recentlyAdded(locale);
                                break;
                            case FeaturedSectionType.ORIGINALS:
                                link = linkToOriginals;
                                break;
                            case FeaturedSectionType.WATCHLIST:
                                title = t("common:watch_list");
                                link = helpers/* Permalink.watchList */.xm.watchList(locale);
                                break;
                        }
                        if (!link) {
                            link = s.genre ? helpers/* Permalink.genre */.xm.genre(s.genre, locale) : helpers/* Permalink.featuredSection */.xm.featuredSection(s, locale);
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySection/* default */.Z, {
                            playlistType: enums/* PlaylistType.Section */.eX.Section,
                            title: title,
                            plays: s.plays,
                            moreHref: link,
                            showResume: s.type === FeaturedSectionType.WATCHING,
                            mediumThumbs: s.type === FeaturedSectionType.CUSTOM_MEDIUM,
                            largeThumbs: s.type === FeaturedSectionType.ORIGINALS
                        }, s.id);
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var browse = (Browse);


/***/ }),

/***/ 11859:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Carousel_carousel__buEkJ"};

/***/ }),

/***/ 86145:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"play":"PlayButton_play__9VaR4","hidden":"PlayButton_hidden__wPqrj"};

/***/ }),

/***/ 820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container-fluid":"browse_container-fluid__H_z7j","homepage":"browse_homepage__YPWYV"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(70047); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);